import { useProactiveMessageListener as useProactiveMessageListenerBase } from '@akin-home/chat-native';
import { useCommandDispatch } from '@akin-home/commands-react';
import { getUserChatID, UserModel } from '@akin-home/user';
import { useCallback } from 'react';
import { ChatItem } from '../ChatItem/types';
import { onReceiveProactiveMessage } from '../functions';
import { useChatApplicationID } from '../stores/useChatApplicationID';

type Params = {
  user: UserModel;
  addItem(item: ChatItem | ChatItem[]): void;
};

/** HeyPixi Tablet App Wrapper for the useProactiveMessageListener */
export const useProactiveMessageListener = (params: Params) => {
  const { user, addItem } = params;

  const application_id = useChatApplicationID();
  const dispatchCommands = useCommandDispatch();

  useProactiveMessageListenerBase({
    application_id,
    username: getUserChatID(user),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    onReceiveMessages: useCallback(
      onReceiveProactiveMessage({ addItem, dispatchCommands }),
      [addItem, dispatchCommands]
    ),
  });
};
